<template>
  <div class="booking-message">
    <div class="booking-message-list">
      <div
        class="booking-message-item"
        v-for="item in Object.values(workList)"
        :key="item.work_type"
      >
        <div class="booking-message-item-title">
          <div class="booking-message-item-title-left">
            {{ item.work_name }}
          </div>
        </div>

        <div
          class="booking-message-item"
          v-for="message in item.messageList"
          :key="message.id"
        >
          <div class="booking-message-item-title">
            <div class="booking-message-item-title-left">
              {{ message.user_name }}
            </div>
            <div
              class="booking-message-message-title-right"
              v-if="message.from_type === 'doctor'"
            >
              <el-button
                :disabled="!!message.is_read"
                :type="message.is_read ? 'info' : 'danger'"
                size="mini"
                @click="markRead(message)"
              >{{ message.is_read ? '已读' : '未读' }}</el-button>
              <el-button
                type="danger"
                size="mini"
                @click="replyHandle(message)"
              >回复</el-button>
            </div>
          </div>

          <div class="booking-message-item-time">
            {{ message.create_time  }}
          </div>
          <div class="booking-message-item-content">
            {{ message.message_content }}
          </div>
        </div>
      </div>
      <van-divider v-if="messageList.length === 0">暂无数据</van-divider>
    </div>
    <van-popup
      v-model="showReplyPopup"
      position="bottom"
    >
      <div class="booking-home-search">
        <div class="booking-home-search-header">
          <div @click="showReplyPopup = false">
            取消
          </div>
          <div
            class="booking-submit"
            @click="messageReply"
          >
            确定
          </div>
        </div>
        <div class="booking-division" />

        <div class="booking-home-search-list">
          <van-field
            v-model="message"
            rows="8"
            label=""
            type="textarea"
            placeholder="请输入您需要回复的内容"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import bookingService from "@/apis/booking";
import enums from "@/views/booking/mixins/enums";
import { Toast } from "vant";

const workMap = {
  tijian: {
    work_type: "tijian",
    work_name: "体检",
  },
  neijing: {
    work_type: "neijing",
    work_name: "内镜",
  },
  waisong: {
    work_type: "waisong",
    work_name: "外送",
  },
};

export default {
  data() {
    return {
      showReplyPopup: false,
      message: "",
      messageList: [],
      workList: [],
      currentInfo: null,
    };
  },
  mixins: [enums],

  created() {
    this.getMessageList();
  },
  methods: {
    markRead(item) {
      const { currentUserInfo } = this;
      const params = {
        message_id: item.id,
        user_id: currentUserInfo.user_id,
        user_name: currentUserInfo.user_name,
      };
      bookingService.messageMarkRead(params).then(() => {
        this.getMessageList();
      });
    },

    getMessageList() {
      const { currentUserInfo } = this;
      const params = {
        user_id: currentUserInfo.user_id,
        apply_id: this.$route.query.id,
      };
      bookingService.messageList(params).then((res) => {
        const workList = {};
        res.forEach((item) => {
          if (!workList[item.work_type]) {
            workList[item.work_type] = workMap[item.work_type];
            workList[item.work_type].messageList = [];
          }
          workList[item.work_type].messageList.push(item);
        });
        this.workList = workList;
        this.messageList = res;
        console.log(res);
      });
    },
    messageMarkRead(id) {
      const { currentUserInfo } = this;

      const params = {
        user_id: currentUserInfo.user_id,
        user_name: currentUserInfo.user_name,
        message_id: id,
      };
      bookingService.messageMarkRead(params);
    },
    messageReply() {
      const { currentUserInfo, message, currentInfo } = this;

      if (!message) {
        Toast("请输入回复内容");
        return;
      }
      const params = {
        user_id: currentUserInfo.user_id,
        user_name: currentUserInfo.user_name,
        message_content: message,
        work_type: currentInfo.work_type,
        work_id: currentInfo.work_id,
      };
      bookingService.messageReply(params).then(() => {
        Toast("回复成功");
        this.showReplyPopup = false;
      });
    },
    replyHandle(item) {
      this.currentInfo = item;
      this.message = "";
      this.showReplyPopup = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-message {
  padding: 20px;
}
.booking-message-list {
}
.booking-message-item {
  border-bottom: 1px solid #e5e5e5;
  padding: 10px 0;
  .booking-message-item-title {
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .booking-message-item-time {
    margin: 5px 0 10px 0;
  }
}
</style>